import { Percent } from '../../../../../../domain/Percent';
import { AttentionStatus } from '../../../../../AttentionStatus';
import {
  EvaluationResult,
  type EvaluationResultType
} from '../../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../../RulesProvider';

export class VoltageDiffPercentEvaluation {
  private readonly ruleName = 'Lv_Busbar_VoltageDiffTransformerEndPercent';

  constructor(private readonly ruleProvider: ForRuleProviding) {}

  public evaluate(voltageDiffPercent: number): EvaluationResultType<Percent> {
    const rule = this.ruleProvider.getRule(this.ruleName);
    const status = AttentionStatus.fromAlertScale(
      rule?.value,
      voltageDiffPercent
    );
    const value = Percent.fromFloat(voltageDiffPercent);
    return EvaluationResult.from(status, value, this.ruleName);
  }
}
